import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

type Tone = 'error' | 'warning' | 'info' | 'success';

const TONES: Record<Tone, string> = {
  error: 'bg-red-50 text-red-800 ring-red-200',
  warning: 'bg-amber-50 text-amber-900 ring-amber-200',
  info: 'bg-brand-50 text-brand-900 ring-brand-200',
  success: 'bg-emerald-50 text-emerald-900 ring-emerald-200',
};

export function Alert({
  tone = 'info',
  title,
  children,
}: {
  tone?: Tone;
  title?: string;
  children: ReactNode;
}) {
  return (
    // role="alert" so the message is announced when it appears, not only when a sighted
    // user happens to look at that part of the page.
    <div role="alert" className={cn('rounded-xl px-4 py-3 text-sm ring-1', TONES[tone])}>
      {title && <p className="font-semibold">{title}</p>}
      <div className={title ? 'mt-0.5' : undefined}>{children}</div>
    </div>
  );
}
